import React, { Component } from "react";
import StarRatings from "react-star-ratings";

// import UI components
import { Row, Col } from "reactstrap";
import { Formik } from "formik";

import CustomisedModal from "components/Application/CustomisedModal";

import { getOrderReviewRequest } from "store/actions";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { compose } from "redux";

import { makeOrderReviewSelectField } from "store/OrderReview/selector";
import { createStructuredSelector } from "reselect";

import injectReducer from "helpers/injectReducer";
import injectSaga from "helpers/injectSaga";
import orderReviewReducer from "store/OrderReview/reducer";
import orderReviewSaga from "store/OrderReview/saga";
import { primaryColor } from "scss/variables.module.scss";

const orderReviewKey = "OrderReview";

const withOrderReviewReducer = injectReducer({
  key: orderReviewKey,
  reducer: orderReviewReducer,
});
const withOrderReviewSaga = injectSaga({
  key: orderReviewKey,
  saga: orderReviewSaga,
});

class OrderReviewForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      reviewFound: false,
      orderReviewData: orderReviewDataInitialState(),
    };
  }

  componentDidMount() {
    this.props.getOrderReviewRequest(this.props.orderRecord.orderDetailId);
  }

  resetForm = (closeModal) => {
    this.setState({
      orderReviewData: orderReviewDataInitialState(),
    });

    if (closeModal) {
      this.props.closeModal();
    }
  };

  UNSAFE_componentWillReceiveProps(nextprops) {
    if (
      nextprops.orderReviewRecord &&
      this.props.orderReviewRecord !== nextprops.orderReviewRecord
    ) {
      if (nextprops.orderReviewRecord.orderReviewId) {
        this.setState({
          reviewFound: true,
          orderReviewData: nextprops.orderReviewRecord,
        });
      } else {
        this.resetForm(false);
      }
    }
  }

  render() {
    return (
      <React.Fragment>
        <CustomisedModal
          modalClass="modal-lg"
          isModalOpen={this.props.formDialog}
          modalTitle="Order Feedback"
          onModalDismiss={() => this.resetForm(true)}
        >
          {this.state.reviewFound ? (
            <Formik
              initialValues={this.state.orderReviewData}
              enableReinitialize={true}
            >
              {({ values }) => (
                <Row>
                  <Col lg="12">
                    <Row className="form-group">
                      <Col sm="4" lg="3">
                        <label>Rating</label>
                      </Col>
                      <Col sm="8" lg="5">
                        <StarRatings
                          rating={values.rating}
                          starRatedColor={primaryColor}
                          starHoverColor={primaryColor}
                          starDimension="35px"
                          starSpacing="4px"
                          numberOfStars={5}
                          name="rating"
                          isAggregateRating={false}
                        />
                      </Col>
                    </Row>

                    <Row className="form-group">
                      <Col sm="4" lg="3">
                        <label>Feedback</label>
                      </Col>
                      <Col sm="8" lg="5" className="border rounded p-2">
                        {values.feedback}
                      </Col>
                    </Row>
                  </Col>
                </Row>
              )}
            </Formik>
          ) : (
            <h5 className="text-center">Review Not Found</h5>
          )}
        </CustomisedModal>
      </React.Fragment>
    );
  }
}

const mapStatetoProps = createStructuredSelector({
  orderReviewRecord: makeOrderReviewSelectField("orderReviewRecord"),
});

const withConnect = connect(mapStatetoProps, {
  getOrderReviewRequest,
});

export default compose(
  withConnect,
  withOrderReviewReducer,
  withOrderReviewSaga,
  withRouter
)(OrderReviewForm);

function orderReviewDataInitialState() {
  return {
    rating: 3,
    feedback: "",
  };
}
